import { Account } from '@/generated-clients/myProfile'
import {
  createMyAccountAPIClient,
} from '@api/MyProfileAPIClientFactory'
import { LoadState } from '@util/types'

// eslint-disable-next-line no-unused-vars
const myAccountApiClient = createMyAccountAPIClient()

function createState () {
  return {
    identityRequest: {
      status: LoadState.None,
      response: [],
    },
    accountRequest: {
      status: LoadState.None,
      response: null as Account | null
    }
  }
}

export default {
  namespaced: true,

  state: createState,

  mutations: {
    IDENTITY_REQUEST (state) {
      state.identityRequest.status = LoadState.Loading
    },
    IDENTITY_RESPONSE (state, payload) {
      state.identityRequest.status = LoadState.Success
      state.identityRequest.response = payload
    },
    IDENTITY_ERROR_RESPONSE (state, payload) {
      state.identityRequest.status = LoadState.Error
      state.identityRequest.response = payload
    },

    ACCOUNT_REQUEST (state) {
      state.accountRequest.status = LoadState.Loading
    },
    ACCOUNT_RESPONSE (state, payload) {
      state.accountRequest.status = LoadState.Success
      state.accountRequest.response = payload
    },
    ACCOUNT_ERROR_RESPONSE (state, payload) {
      state.accountRequest.status = LoadState.Error
      state.accountRequest.response = payload
    },
  },

  actions: {
    fetchIdentity ({ commit }) {
      commit('IDENTITY_REQUEST')
      return new Promise((resolve, reject) => {
        myAccountApiClient
          .getIdentity()
          .then((response) => {
            commit('IDENTITY_RESPONSE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            commit('IDENTITY_ERROR_RESPONSE', error.response)
            reject(error)
          })
      })
    },

    fetchAccountDetails ({ commit }) {
      commit('ACCOUNT_REQUEST')
      return new Promise((resolve, reject) => {
        myAccountApiClient
          .getAccountInformation()
          .then((response) => {
            commit('ACCOUNT_RESPONSE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            commit('ACCOUNT_ERROR_RESPONSE', error.response)
            reject(error)
          })
      })
    },
  },

  getters: {
    getIdentity: state => state.identityRequest.response,
    getIdentityStatus: state => state.identityRequest.status,
    isGetIdentitySuccess: state => state.identityRequest.status === LoadState.Success,
    isGetIdentityError: state => state.identityRequest.status === LoadState.Error || state.identityRequest.status === LoadState.Unauthorized,

    getAccount: state => state.accountRequest.response,
    getAccountStatus: state => state.accountRequest.status,
    isGetAccountSuccess: state => state.accountRequest.status === LoadState.Success,
    isGetAccountError: state => state.accountRequest.status === LoadState.Error || state.accountRequest.status === LoadState.Unauthorized,
  },
}
